  
export const REPOS_LIST_REQUEST = 'REPOS_LIST_REQUEST'
export const REPOS_LIST_SUCCESS = 'REPOS_LIST_SUCCESS'
export const REPOS_LIST_FAIL = 'REPOS_LIST_FAIL'